import CustomLabel from "components/common/CustomLabel";
import DetailsPageTitle from "components/common/DetailsPageTitle";
import NoDataFound from "components/common/NoDataFound";
import SingleSelect from "components/common/SingleSelect";
import Spinners from "components/common/Spinners";
import React, { useEffect, useState } from "react";
import { Badge, Col, Container, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { getOrganisationDetails } from "store/actions/organizationSlice";
import { showAlert } from "store/reducers/alertReducer";
import UpdateOrganizationSettings from "./UpdateOrganizationSettings";
import UpdateOrganizationManager from "./UpdateOrganizationManager";

const OrganisationDetails = () => {
  const { t } = useTranslation();
  document.title = t("Organization Details | Work Space");

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const dispatch = useDispatch();

  const { gettingDetails, organisationDetails } = useSelector(
    (state) => state.Organizations
  );

  const [selectedTab, setSelectedTab] = useState(1);

  useEffect(() => {
    const getDetails = () => {
      const payload = {
        id,
      };
      dispatch(getOrganisationDetails(payload));
    };
    getDetails();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content common_details_page order_details">
        {gettingDetails ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <DetailsPageTitle title={t("Organisation Details")} />
              <Col lg={12}>
                <div className="tab_btns mt-2">
                  <button
                    className={selectedTab === 1 ? "active" : ""}
                    onClick={() => setSelectedTab(1)}
                  >
                    {t("Organization Details")}
                  </button>
                  <button
                    className={selectedTab === 2 ? "active" : ""}
                    onClick={() => setSelectedTab(2)}
                  >
                    {t("Organization Settings Details")}
                  </button>
                  <button
                    className={selectedTab === 3 ? "active" : ""}
                    onClick={() => setSelectedTab(3)}
                  >
                    {t("Organization Manager Details")}
                  </button>
                </div>
              </Col>
            </Row>
            {selectedTab === 1 && (
              <div className="common_wrapper mt-2">
                <Row>
                  <Col lg={12}>
                    <div className="common_card_inner order_customer_details mt-0">
                      <div className="d-flex flex-wrap gap-5">
                        <div className="inner_details">
                          <h2>{t("Name")}</h2>
                          <h3>{t(organisationDetails.name)}</h3>
                        </div>
                        <div className="inner_details">
                          <h2>{t("Phone")}</h2>
                          <h3>{organisationDetails.phone || "-"}</h3>
                        </div>
                        <div className="inner_details">
                          <h2>{t("Email")}</h2>
                          <h3>{organisationDetails.email || "-"}</h3>
                        </div>
                        <div className="inner_details">
                          <h2>{t("Company Name")}</h2>
                          <h3>
                            {organisationDetails?.companyDetails?.companyName ||
                              "-"}
                          </h3>
                        </div>
                        <div className="inner_details">
                          <h2>{t("Commercial Number")}</h2>
                          <h3>
                            {organisationDetails?.companyDetails
                              ?.commercialNumber || "-"}
                          </h3>
                        </div>
                        <div className="inner_details">
                          <h2>{t("VAT Number")}</h2>
                          <h3>
                            {organisationDetails?.companyDetails?.vatNumber ||
                              "-"}
                          </h3>
                        </div>
                        <div className="inner_details">
                          <h2>{t("Status")}</h2>

                          <Badge
                            bg={
                              organisationDetails.status === 1
                                ? " bg_primary"
                                : " bg-secondary"
                            }
                          >
                            {organisationDetails.status === 1
                              ? t("Active")
                              : t("Deactive")}
                          </Badge>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            )}
            {selectedTab === 2 && <UpdateOrganizationSettings />}
            {selectedTab === 3 && <UpdateOrganizationManager />}
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default OrganisationDetails;
